import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { Button } from './ui/Button';
import { ProductMockup } from './ui/ProductMockup';
import { StarIcon } from 'lucide-react';
export function SpecialOffer() {
  const {
    specialOffer,
    global
  } = pageData;
  // Simple 24h countdown timer
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        }; // reset
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="offer" className="px-3 md:px-4 py-10 md:py-24 bg-navy-900 border-y border-white/5" data-id="element-158">
      <div className="max-w-4xl mx-auto w-full" data-id="element-159">
        <div className="text-center mb-4 md:mb-8" data-id="element-160">
          <span className="inline-block bg-red-600 text-white font-bold text-[10px] md:text-xs px-3 md:px-4 py-1 md:py-1.5 rounded-full uppercase tracking-widest mb-3 md:mb-6" data-id="element-161">
            {specialOffer.pill}
          </span>
          <h2 className="text-2xl md:text-4xl text-gold-500" data-id="element-162">
            {specialOffer.heading}
          </h2>
        </div>

        <div id="offer-card" className="bg-slate-850 border-2 border-gold-500/20 rounded-2xl md:rounded-3xl p-4 md:p-12 relative overflow-hidden shadow-2xl scroll-mt-3 md:scroll-mt-8" data-id="element-163">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent opacity-50" data-id="element-164" />

          <div className="origin-top mb-2 md:mb-4" data-id="element-165">
            <div className="flex justify-center" data-id="element-166">
              <ProductMockup data-id="element-167" />
            </div>
          </div>

          <div id="offer-purchase" className="text-center mt-3 pt-4 md:mt-8 md:pt-8 border-t border-slate-800 scroll-mt-4" data-id="element-168">
            <div className="text-slate-400 line-through text-base md:text-xl mb-1 md:mb-2" data-id="element-169">
              Regular Price: {global.currency} {global.originalPrice}
            </div>
            <div className="text-gold-500 font-bold tracking-widest uppercase text-xs md:text-sm mb-0.5 md:mb-1" data-id="element-170">
              TODAY ONLY
            </div>
            <div className="text-5xl md:text-7xl font-display text-white mb-2 md:mb-4" data-id="element-171">
              {global.currency} {global.price}
            </div>
            <div className="text-sm md:text-base text-slate-400 mb-4 md:mb-8" data-id="element-172">
              {specialOffer.paymentType}
            </div>

            {/* Urgency message */}
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-4 md:mb-6 px-2" data-id="element-173">
              <span className="text-xl md:text-2xl shrink-0" aria-hidden="true" data-id="element-174">
                🔥
              </span>
              <p className="text-red-500 font-bold text-base md:text-2xl leading-tight text-balance" data-id="element-175">
                Last Chance! This price increases when the countdown expires.
              </p>
            </div>

            {/* Countdown */}
            <div className="flex justify-center gap-3 md:gap-4 mb-5 md:mb-10" data-id="element-176">
              <TimeUnit value={timeLeft.hours} label="HOURS" data-id="element-177" />
              <div className="text-2xl md:text-3xl text-gold-500 font-display mt-2" data-id="element-178">
                :
              </div>
              <TimeUnit value={timeLeft.minutes} label="MINUTES" data-id="element-179" />
              <div className="text-2xl md:text-3xl text-gold-500 font-display mt-2" data-id="element-180">
                :
              </div>
              <TimeUnit value={timeLeft.seconds} label="SECONDS" data-id="element-181" />
            </div>

            <div id="offer-cta" className="scroll-mt-24 scroll-mb-6" data-id="element-182">
              <Button className="mb-3 md:mb-6 text-lg md:text-3xl px-8 py-5 md:px-10 md:py-6" onClick={() => {
              window.location.href = global.checkoutUrl;
            }} data-id="element-183">
                {specialOffer.ctaText}
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2" data-id="element-184">
              <div className="flex text-gold-500 shrink-0" data-id="element-185">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-186" />)}
              </div>
              <span className="text-xs md:text-sm text-slate-400 font-medium text-center" data-id="element-187">
                500+ Coaches trust this system
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function TimeUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-188">
      <div className="w-14 h-14 md:w-20 md:h-20 bg-navy-950 border border-slate-800 rounded-xl flex items-center justify-center text-2xl md:text-4xl font-display text-gold-500 shadow-inner" data-id="element-189">
        {value.toString().padStart(2, '0')}
      </div>
      <div className="text-[9px] md:text-xs font-bold text-slate-500 mt-1.5 md:mt-2 tracking-widest" data-id="element-190">
        {label}
      </div>
    </div>;
}